import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import Theme from 'components/common/Theme/Theme'
import Mixin from 'components/common/Mixin'
import Media from 'components/common/Media'
import { H2 } from 'components/common/Text/Text'
import { ServiceIcon } from 'components/common/ServiceIcon'
import UpdatingBlock from 'components/common/UpdatingBlock'
import kebabCase from 'lodash/kebabCase'
import { ADDING_TO_SHOPPING_QUOTE } from 'components/common/UpdatingBlock/constants'
import ServiceDescription from '../ServiceDescription'
import Button from 'components/common/Button/Button'

const Service = ({
  displayName,
  description = '',
  iconName = '',
  quantity = 1,
  serviceSeo,
  skuId,
  price,
  onClick,
  expanded = false
}) =>
  <Wrapper
    data-at-servicecategory-service={ kebabCase(displayName) }
    name={ ADDING_TO_SHOPPING_QUOTE }
    value={ skuId }>
    <Information>
      <ServiceIconCustom data-at-icon grey iconName={ iconName } condition larger />
      <ServiceName narrow data-at-name bolder>
        { displayName }
        <Media.ScreenReader>about { displayName }</Media.ScreenReader>
      </ServiceName>
      <ServiceDescriptionWrapper data-at-description>
        <ServiceDescription
          skuId={ skuId }
          description={ description }
          expandedByDefault={ expanded } />
      </ServiceDescriptionWrapper>
      { price > 0 && <Price>{`$${price}`}</Price> }
    </Information>
    <QuickAppointmentButton
      data-at-servicecategory-service-quickapp
      productInfo={{
        skuId,
        quantity
      }}
      onClick={ onClick } >
      ADD & SCHEDULE
    </QuickAppointmentButton>
  </Wrapper>


Service.propTypes = {
  description: PropTypes.string,
  displayName: PropTypes.string,
  expanded: PropTypes.bool,
  iconName: PropTypes.string,
  onClick: PropTypes.func,
  price: PropTypes.number,
  quantity: PropTypes.number,
  serviceSeo: PropTypes.string,
  skuId: PropTypes.string
}

export default Service

const Wrapper = styled(UpdatingBlock)`
  text-align: left;
  ${Media.desktop`
    display: inline-block;
    vertical-align: top;
    width: 50%;
  `}
  ${Mixin.responsive('padding', '30px 12px 30px 180px', '20px 0')}
`

const Information = styled.div`
  ${Media.desktop`
    min-height: 140px;
    margin-left: 10px;
    margin-bottom: 20px;
  `}
`

const ServiceIconCustom = styled(ServiceIcon)`
  float: left;
  ${Mixin.responsive('margin', '25px 0 30px -190px', '0 16px 0 0')}
  ${Mixin.responsive('width', '152px', '30px')}
  ${Mixin.responsive('height', '152px', '30px')}
`

const ServiceName = styled(H2)`
  ${Mixin.responsive('display', 'inline-block', 'block')}
  ${Mixin.font.GothamBold(26)}
  ${Mixin.responsive('font-size', '26px', '20px')}
`

const ServiceDescriptionWrapper = styled.div`
  overflow: hidden;
  line-height: 22px;
  padding-bottom: 5px;
`

const Price = styled.div`
  margin: 0 0 10px;
  color: ${Theme.colors.black_new};
  ${Mixin.font.GothamMedium(14, 500, 24)}
`

const QuickAppointmentButton = styled(Button)`
  display: inline-block;
  padding: 7px 30px 8px;
  color: ${Theme.colors.white};
  text-align: center;
  text-decoration: none;
  text-transform: uppercase;
  vertical-align: middle;
  background: ${Theme.colors.bright_red_new};
  border: 1px solid ${Theme.colors.bright_red_new};
  border-radius: 0;
  ${Mixin.font.GothamBold(13)}
  font-stretch: condensed;
  transform: scale(1, 1.3);
  line-height: 1.05em;
  letter-spacing: 0;
  cursor: pointer;
  ${Media.desktop`
    margin-left: 10px;
  `}
`
